import { AttributeKey } from 'types/models/company';
import InputChip from 'storybookConfig/stories/molecules/Chip/InputChip';
import Flex from '@react-css/flex';
import Body from 'storybookConfig/stories/molecules/Body';

export const attributesMap: Record<AttributeKey, { label: string; description: string }> = {
  [AttributeKey.MADE_IN_USA]: {
    label: 'Made in USA',
    description: "Your brand's products are made inside of the United States of America.",
  },
  [AttributeKey.ECO_FRIENDLY]: {
    label: 'Eco-friendly',
    description:
      'Your brand uses sustainable materials or environmentally conscious production methods.',
  },
  [AttributeKey.SOCIAL_GOOD]: {
    label: 'Social Good',
    description:
      'Your brand is committed to positive social impact, such as fair labor practices or charitable giving.',
  },
  [AttributeKey.GLUTEN_FREE]: {
    label: 'Gluten Free',
    description: "Your brand's products are gluten free.",
  },
  [AttributeKey.ORGANIC]: {
    label: 'Organic',
    description:
      'Your products are made with certified organic ingredients or follow organic farming standards.',
  },
  [AttributeKey.PLANT_BASED]: {
    label: 'Plant Based',
    description: 'Your products are derived from plants and contain no animal ingredients.',
  },
  [AttributeKey.VEGAN]: {
    label: 'Vegan',
    description:
      'Your products contain no animal-derived ingredients and are not tested on animals.',
  },
  [AttributeKey.KOSHER_CERTIFIED]: {
    label: 'Kosher Certified',
    description: "Your brand's products are kosher certified.",
  },
  [AttributeKey.WOMAN_OWNED]: {
    label: 'Woman Owned',
    description: 'Your business is owned or led by one or more women.',
  },
  [AttributeKey.LGBTQ_OWNED]: {
    label: 'LGBTQIA+ Owned',
    description:
      'Your business is owned or led by someone who identifies as part of the LGBTQIA+ community.',
  },
  [AttributeKey.AAPI_OWNED]: {
    label: 'AAPI Owned',
    description: 'Your business is owned or led by someone who identifies as AAPI.',
  },
  [AttributeKey.BIPOC_OWNED]: {
    label: 'BIPOC Owned',
    description: 'Your business is owned or led by someone who identifies as BIPOC.',
  },
  [AttributeKey.BLACK_OWNED]: {
    label: 'Black Owned',
    description: 'Your business is owned or led by someone who identifies as Black.',
  },
  [AttributeKey.LATINO_OWNED]: {
    label: 'Latino Owned',
    description: 'Your business is owned or led by someone who identifies as Latino or Hispanic.',
  },
};

interface AttributesSelectorProps {
  selectedAttributes: AttributeKey[];
  onAttributeClick: (key: AttributeKey) => void;
}

const AttributesSelector = ({ selectedAttributes, onAttributeClick }: AttributesSelectorProps) => {
  return (
    <>
      {Object.entries(attributesMap).map(([key, { label, description }]) => (
        <Flex key={key} gap="8px" column alignItems="flex-start">
          <InputChip
            selected={selectedAttributes?.includes(key as AttributeKey)}
            onClick={() => onAttributeClick(key as AttributeKey)}
          >
            {label}
          </InputChip>
          <Body variant="Body/Regular" color="bodyTextSecondary">
            {description}
          </Body>
        </Flex>
      ))}
    </>
  );
};

export default AttributesSelector;
